import { http, HttpResponse } from 'msw';
import { fetchProductsSuccessResponse } from '../../utilities/tests/mock-products';
import { PRODUCTS_URL } from '../../utilities/route-mappings';

const getAccounts = http.get(PRODUCTS_URL(), () => {
  return HttpResponse.json(fetchProductsSuccessResponse);
});

export default [getAccounts];
